<template>
	<div class="kbBox" v-loading.fullscreen.lock="fullscreenLoading">
		<div class="kbTit">
			<div class="kbFanh" @click="fhKeben()">
				<i class="el-icon-arrow-left"></i>
				返回课本
			</div>
			<div class="kbTj banjJcBtn">
				<i class="el-icon-notebook-1"></i>
				错题分布
			</div>
		</div>
		<div class="kbCont">
			<table class="kbTab" :style="{ width: (thData?.split(',').slice(0, num).length + 1) * 60 + 120 + 'px' }">
				<tr class="kbTr">
					<th class="kbTh">
						<span class="sp1">题号</span>
						<span class="sp2">章节</span>
					</th>
					<th v-for="(item, index) in thData?.split(',').slice(0, num)" :key="index">{{ item }}</th>
				</tr>
				<tr v-for="(i, s) in tabList" class="trBox" :key="s">
					<td class="titTd" :title="i.name" @click="zjBtns(i, tabList)">
						<div :title="i.name">
							{{ i.name }}
						</div>
					</td>
					<td v-for="(item, index) in i.children" @click="btns(item, i.children, s)" :style="{ cursor: item.name ? 'pointer' : '' }" :key="index">{{ item.name }}</td>
				</tr>
			</table>
		</div>
	</div>
</template>

<script>
// 引入引导库（例如shepherd.js）
import Shepherd from 'shepherd.js';
import 'shepherd.js/dist/css/shepherd.css';
export default {
	name: 'cuotiFb',
	data() {
		return {
			thData: '一,二,三,四,五,六,七,八,九,十,十一,十二,十三,十四,十五,十六,十七,十八,十九,二十,二十一,二十二,二十三,二十四,二十五,二十六,二十七,二十八,二十九,三十',
			tours: '',
			num: '',
			tabList: [],
			tableData: [],
			kbenData: [],
			fullscreenLoading: false
		};
	},
	props: ['retTxt', 'ctId', 'bjId'],
	methods: {
		fhKeben() {
			console.log(this.retTxt, 8888);
			this.$emit('fhBtn', this.retTxt);
		},
		zjBtns(item, arr) {
			if (item.id) {
				this.$emit('exaArrFn', arr);
				this.$emit('exaFn', item);
				this.$emit('fhBtn', 'cuotiJlu');
			}
		},
		btns(item, arr, s) {
			// if (!item.name) {
			// 	return;
			// }
			console.log(item, arr, 8888233333333333);
			let as = arr.filter((items) => 
				{
					// items.name != ''
					return true
				}
			);
			// 用 Set 记录已出现的 id
			const seenIds = new Set();
			const result = as.filter((item) => {
				if (seenIds.has(item.txt)) {
					return false; // 已存在则过滤
				} else {
					seenIds.add(item.txt); // 不存在则记录并保留
					return true;
				}
			});
			console.log(result, 554444);
			if (item.id) {
				item.s = s + 1;
				this.$emit('exaFn', item);
				this.$emit('exaArrFn', result);
				this.$emit('fhBtn', 'cuotiFbjlu');
			}
		},
		init() {
			this.fullscreenLoading = true;
			this.$http.get(`api/app/yydTextbook/answerStatistics/${this.ctId}/${this.bjId}`).then((res) => {
				console.log(res, 123333);
				this.fullscreenLoading = false;
				this.zyinBtn();
				if (res.code == 200) {
					// this.tableData = res.data
					if (res.data.yydTextbookDirectoryList.length) {
						this.dgFn(res.data.yydTextbookDirectoryList);
						this.$nextTick((item) => {
							this.tabList.forEach((is, s) => {
								if (is.children.length < this.num) {
									let nums = this.num - is.children.length;
									for (let a = 0; a < nums; a++) {
										is.children.push({
											id: '',
											name: '',
											txt: ''
										});
									}
								}
							});
						});
					}
					console.log(this.tabList, 55555);
				}
			});
		},
		gshFn() {
			// let num = 0
			// let arr = []
			// for(let item of this.tableData.yydTextbookDirectoryList
			// ){
			//   for(let i of item.children){
			//     let items = {
			//       name: i.name,
			//       id: i.textbookDirectoryId,
			//       children:[]
			//     }
			//     if(i.children.length>num){
			//       num = i.children.length
			//     }
			//     for(let s of i.children){
			//       items.children.push({
			//         txt: s.name,
			//         name: s.yydTextbookQuestions.length,
			//         id: s.textbookDirectoryId,
			//       })
			//     }
			//     arr.push(items)
			//   }
			// }
			// for(let item of arr){
			//   for(let i=0;i<10;i++){
			//     console.log(1111111)
			//     if(!item.children[i]){
			//       item.children.push({
			//         name:'',
			//         id:'',
			//       })
			//     }
			//   }
			// }
		},
		dgFn(data) {
			console.log(data, 7777);
			for (let item of data) {
				if (item.children) {
					this.dgFn(item.children);
				} else {
					let val = {
						id: item.textbookDirectoryId,
						name: item.name,
						children: []
					};
					let n = 0;
					item.yydTextbookQuestions.forEach((item) => {
						item.yydSmallQuestionList.forEach((i) => {
							n++;
						});
					});
					if (n > this.num) {
						this.num = n;
					}
					let arr = [];
					item.yydTextbookQuestions.forEach((item) => {
						item.yydSmallQuestionList.forEach((i) => {
							arr.push({
								id: item.examinationQuestionId,
								name: i.wrongNums || 0,
								txt: item.number
							});
						});
					});
					val.children = arr;
					this.tabList.push(val);
					console.log(this.tabList, 9999);
				}
			}
		},
		zyinBtn() {
			if (sessionStorage.getItem('isXf')) {
				return;
			}
			this.tours = new Shepherd.Tour({
				useModalOverlay: true,
				defaultStepOptions: {
					classes: 'shadow-md bg-purple-dark',
					scrollTo: true
				}
			});
			this.tours.cancel();
			this.tours.addStep({
				text: `
                  <h2 class="tcTit">
                    滑动可以查看剩余部分
                  </h2>
                  <p class="tcP">
                    滑动可以查看剩余部分
                  </p>
                `,
				attachTo: {
					element: '.kbTr', // 指定元素的选择器
					on: 'bottom'
				},
				buttons: [
					{
						text: '我知道了',
						action: this.tours.next
					}
				]
			});
			this.tours.start();
			sessionStorage.setItem('isXf', 1);
		}
	},
	mounted() {
		this.init();
	}
};
</script>
<style lang="scss" scoped>
.kbBox {
	width: 1060px;
}
.kbTit {
	height: 80px;
	// border-bottom: 1px solid #EEEFF2;
	display: flex;
	align-items: center;
	padding: 0 26px 0 16px;
	justify-content: space-between;
	> div {
		display: flex;
		align-items: center;
		font-size: 14px;
		cursor: pointer;
		color: #000000;
		line-height: 1;
		img {
			width: 22px;
			height: 22px;
			margin-right: 4px;
		}
		i {
			margin-right: 4px;
			font-size: 16px;
		}
	}
	.banjJcBtn {
		width: 90px;
		height: 30px;
		background: #fa4a1b;
		border-radius: 4px;
		font-size: 14px;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		i {
			font-size: 16px;
			margin-right: 4px;
		}
	}
}
.kbCont {
	margin: 0 26px 0 16px;
	box-sizing: border-box;
	max-width: 100%;
	overflow-x: auto;
	border-top: 1px solid #e7e8ec;
	border-left: 1px solid #e7e8ec;
	.kbTab {
		border-collapse: collapse;
		box-sizing: border-box;
		th,
		td {
			width: 58px;
			height: 48px;
			text-align: center;
			line-height: 48px;
			border-right: 1px solid #e7e8ec;
			border-bottom: 1px solid #e7e8ec;
			font-size: 14px;
			color: #000000;
			&:first-of-type {
				width: 65px;
			}
		}

		.kbTr {
			th {
				background: #f3f4f7;
			}
			.kbTh {
				position: sticky;
				left: 0;
				font-size: 12px;
				overflow: hidden;
				width: 120px;

				&::before {
					content: '';
					position: absolute;
					width: 210px;
					height: 1px;
					background: #e7e8ec;
					top: 50%;
					left: -19px;
					transform: rotate(14.8deg);
				}
				.sp1 {
					position: absolute;
					top: 8px;
					right: 12px;
					line-height: 1;
				}
				.sp2 {
					position: absolute;
					bottom: 8px;
					left: 14px;
					line-height: 1;
				}
			}
		}
	}
}
.tcTit {
	color: #fff;
	font-weight: bold;
	font-size: 16px;
}
.tcP {
	font-size: 14px;
	margin-top: 9px;
	color: #fff;
}
.trBox {
	.titTd {
		position: sticky;
		left: 0;
		div {
			width: 150px;
			padding: 0 10px;
			box-sizing: border-box;
			background: #fff;
			cursor: pointer;
			overflow: hidden; /* 确保超出容器的内容被裁剪 */
			white-space: nowrap; /* 确保文本在一行内显示 */
			text-overflow: ellipsis; /* 超出部分显示省略号 */
		}
	}
	td {
	}
}
</style>
